export default () => jQuery(($) => {
	var countdown_setCircleDashArray = function (fraction, elem) {
		var circleDasharray = `${(fraction * 283).toFixed(0)} 283`;
		elem.attr('stroke-dasharray', circleDasharray);
	}

	var blendColors = function (colorA, colorB, amount) {
		const [rA, gA, bA] = colorA.match(/\w\w/g).map((c) => parseInt(c, 16));
		const [rB, gB, bB] = colorB.match(/\w\w/g).map((c) => parseInt(c, 16));
		const r = Math.round(rA + (rB - rA) * amount).toString(16).padStart(2, '0');
		const g = Math.round(gA + (gB - gA) * amount).toString(16).padStart(2, '0');
		const b = Math.round(bA + (bB - bA) * amount).toString(16).padStart(2, '0');
		return '#' + r + g + b;
	}

	$('.scheduledContent__countdown').each(function () {
		var targetDate = $(this).attr('data-countdown-target');
		var targetElement = $(this).find('.scheduledContent__countdownTimer');
		var targetDateObj = new Date(targetDate.replace(/-/g, '/'));
		var counterStyle = $(this).attr('data-countdown-style');

		// Set the date we're counting down to
		var countdownDate = targetDateObj.getTime();

		// Update the countdown every 1 second
		targetElement.append('<span class="countdownSegment countdownDays"></span><span class="countdownSegment countdownHours"></span><span class="countdownSegment countdownMinutes"></span><span class="countdownSegment countdownSeconds"></span>');
		var targetElement__days = $(this).find('.countdownDays');
		var targetElement__hours = $(this).find('.countdownHours');
		var targetElement__minutes = $(this).find('.countdownMinutes');
		var targetElement__seconds = $(this).find('.countdownSeconds');
		switch (counterStyle) {
			case 'boxes':
				targetElement__days.html(`<span class="number"></span><span class="label">days</span>`);
				targetElement__hours.html(`<span class="number"></span><span class="label">hours</span>`);
				targetElement__minutes.html(`<span class="number"></span><span class="label">minutes</span>`);
				targetElement__seconds.html(`<span class="number"></span><span class="label">seconds</span>`);
				break;

			case 'rings':
				targetElement__days.html(`<svg class="timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><g class="timer__circle"><circle class="timer__elapsed" cx="50" cy="50" r="45" /><path
        stroke-dasharray="283"
        class="timer__remaining"
        d="
          M 50, 50
          m -45, 0
          a 45,45 0 1,0 90,0
          a 45,45 0 1,0 -90,0
        "
      ></path></g></svg><span class="labelComplete"><span class="label">days</span><span class="number"></span></span>`);
				targetElement__hours.html(`<svg class="timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><g class="timer__circle"><circle class="timer__elapsed" cx="50" cy="50" r="45" /><path
        stroke-dasharray="283"
        class="timer__remaining"
        d="
          M 50, 50
          m -45, 0
          a 45,45 0 1,0 90,0
          a 45,45 0 1,0 -90,0
        "
      ></path></g></svg><span class="labelComplete"><span class="label">hours</span><span class="number"></span></span>`);
				targetElement__minutes.html(`<svg class="timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><g class="timer__circle"><circle class="timer__elapsed" cx="50" cy="50" r="45" /><path
        stroke-dasharray="283"
        class="timer__remaining"
        d="
          M 50, 50
          m -45, 0
          a 45,45 0 1,0 90,0
          a 45,45 0 1,0 -90,0
        "
      ></path></g></svg><span class="labelComplete"><span class="label">minutes</span><span class="number"></span></span>`);
				targetElement__seconds.html(`<svg class="timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><g class="timer__circle"><circle class="timer__elapsed" cx="50" cy="50" r="45" /><path
        stroke-dasharray="283"
        class="timer__remaining"
        d="
          M 50, 50
          m -45, 0
          a 45,45 0 1,0 90,0
          a 45,45 0 1,0 -90,0
        "
      ></path></g></svg><span class="labelComplete"><span class="label">seconds</span><span class="number"></span></span>`);
				break;

			case 'simple':
			default:
				targetElement__days.html(`<span class="number"></span><span class="label">d</span>`);
				targetElement__hours.html(`<span class="number"></span><span class="label">h</span>`);
				targetElement__minutes.html(`<span class="number"></span><span class="label">m</span>`);
				targetElement__seconds.html(`<span class="number"></span><span class="label">s</span>`);
				break;
		}

		var x = setInterval(function () {
			// Get today's date and time
			var now = new Date().getTime();

			// Find the distance between now and the countdown date
			var distance = countdownDate - now;

			// Time calculations for days, hours, minutes and seconds
			var days = Math.floor(distance / (1000 * 60 * 60 * 24));
			var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((distance % (1000 * 60)) / 1000);

			// Display the result in the element with id="demo"
			// targetElement.html( days + "d " + hours + "h " + minutes + "m " + seconds + "s " );
			var targetElement__daysNumber = targetElement__days.find('.number');
			var targetElement__hoursNumber = targetElement__hours.find('.number');
			var targetElement__minutesNumber = targetElement__minutes.find('.number');
			var targetElement__secondsNumber = targetElement__seconds.find('.number');

			targetElement__daysNumber.html(days);
			targetElement__hoursNumber.html(hours);
			targetElement__minutesNumber.html(minutes);
			targetElement__secondsNumber.html(seconds);
			if (counterStyle === 'rings') {
				var green = '008800';
				var blue = '0b5091';
				var yellow = 'f3b61d';
				var red = 'cc0000';
				var colorComplete = '7ca0c9';
				var targetElement__daysRing = targetElement__days.find('.timer__remaining');
				var targetElement__hoursRing = targetElement__hours.find('.timer__remaining');
				var targetElement__minutesRing = targetElement__minutes.find('.timer__remaining');
				var targetElement__secondsRing = targetElement__seconds.find('.timer__remaining');

				if (seconds === 59) {
					targetElement__seconds.find('.timer__svg').css('transform', 'scaleX(1)');
				} else if (seconds === 58) {
					targetElement__seconds.find('.timer__svg').css('transform', 'scaleX(-1)');
				}
				if (days === 0 && hours === 0 && minutes === 0) {
					targetElement__secondsRing.css({stroke: blendColors(red, yellow, seconds / 55)});
				} else if (seconds > 30) {
					targetElement__secondsRing.css({stroke: blendColors(green, blue, (seconds - 30) / 30)});
				} else if (seconds > 5) {
					targetElement__secondsRing.css({stroke: blendColors(yellow, green, (seconds - 5) / 25)});
				} else {
					targetElement__secondsRing.css({stroke: `#${yellow}`});
				}
				countdown_setCircleDashArray(seconds / 60, targetElement__secondsRing);
				if (days === 0 && hours === 0 && minutes === 0) {
					targetElement__minutesRing.css({strokeWidth: '6px', stroke: `#${colorComplete}`});
					countdown_setCircleDashArray(1, targetElement__minutesRing);
				} else {
					if (minutes === 59) {
						targetElement__minutes.find('.timer__svg').css('transform', 'scaleX(1)');
					} else if (minutes === 58) {
						targetElement__minutes.find('.timer__svg').css('transform', 'scaleX(-1)');
					}
					if (minutes > 20) {
						targetElement__minutesRing.css({stroke: blendColors(green, blue, (minutes - 20) / 40)});
					} else {
						targetElement__minutesRing.css({stroke: blendColors(yellow, green, minutes / 20)});
					}
					countdown_setCircleDashArray(minutes / 60, targetElement__minutesRing);
				}
				if (days === 0 && hours === 0) {
					targetElement__hoursRing.css({strokeWidth: '6px', stroke: `#${colorComplete}`});
					countdown_setCircleDashArray(1, targetElement__hoursRing);
				} else {
					if (hours > 8) {
						targetElement__hoursRing.css({stroke: blendColors(green, blue, (hours - 8) / 16)});
					} else {
						targetElement__hoursRing.css({stroke: blendColors(yellow, green, hours / 8)});
					}
					countdown_setCircleDashArray(hours / 24, targetElement__hoursRing);
				}
				if (days === 0) {
					targetElement__daysRing.css({strokeWidth: '6px', stroke: `#${colorComplete}`});
					countdown_setCircleDashArray(1, targetElement__daysRing);
				} else {
					if (days > 30) {
						targetElement__daysRing.css({stroke: blendColors(green, blue, (days - 30) / 335)});
					} else {
						targetElement__daysRing.css({stroke: blendColors(yellow, green, days / 30)});
					}
					countdown_setCircleDashArray(days / 365, targetElement__daysRing);
				}
			}

			// If the countdown is finished, redirect
			if (distance < 0) {
				clearInterval(x);
				targetElement.html('<h3 class="scheduledContent__countdownTimerComplete">It is time!</h3>');
				setTimeout(function () {
					location.reload();
				}, 1000);
			}
		}, 1000);
	});
});
